import { appsignal } from "./appsignal";

export function base64ToArray(base64String) {
    return Uint8Array.from(window.atob(base64String), (c) => c.charCodeAt(0));
}

export function arrayBufferToBase64(buffer) {
    return window.btoa(Array.from(new Uint8Array(buffer), (c) => String.fromCharCode(c)).join(""));
}

// Rendered and laid out, so the user can actually focus it.
export function isVisible(element) {
    if (typeof element.checkVisibility === "function") {
        return element.checkVisibility();
    }

    return element.getClientRects().length > 0;
}

export function handleError(error, context) {
    console.error(`WebAuthn error:`, error);
    appsignal.sendError(error);
    const { message, name, stack } = error;
    // pushEventTo rejects when the socket is down, so a bare call would turn the
    // one error we are reporting into two -- the real one plus an unhandled
    // "LiveView not connected" rejection landing next to it in monitoring.
    return context.pushEventTo(context.el, "error", { message, name, stack }).catch(() => {});
}

export function handleCeremonyError(error, context, { automatic = false } = {}) {
    if (error?.name === "NotAllowedError") {
        // The user dismissed the system sheet. AbortControllerService has already
        // released the ceremony, so the next tap starts a fresh one.
    } else if (error?.name === "AbortError") {
        // The ceremony that replaced this one reports its own outcome.
    } else if (automatic) {
        // Page-initiated: nothing the user can see or retry.
        console.info("Passkey autofill unavailable:", error);
    } else {
        handleError(error, context);
    }
}

// LiveView rejects pushEvent when the socket is not connected -- a backgrounded
// PWA, a network blip, a deploy restart. A bare `pushEvent(event, payload)` has
// no reply callback, so LiveView never attaches a .catch and the rejection
// surfaces as "unable to push hook event. LiveView not connected". For events
// the user can simply repeat (a scroll, a tap, a swipe) losing one is harmless,
// so swallow it. Events carrying state the server cannot rebuild on its own
// must NOT use this -- hold those and re-push them on reconnect instead.
export function pushRetryableEvent(hook, event, payload = {}) {
    return hook.pushEvent(event, payload).catch(() => {});
}
